import { render, staticRenderFns } from "./OrderComboboxSearch.vue?vue&type=template&id=990325bc&scoped=true&%23contentTemplate=%7B%7D"
import script from "./OrderComboboxSearch.vue?vue&type=script&lang=js"
export * from "./OrderComboboxSearch.vue?vue&type=script&lang=js"
import style0 from "./OrderComboboxSearch.vue?vue&type=style&index=0&id=990325bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990325bc",
  null
  
)

export default component.exports